import React from "react";
import { Box, Button, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getUserCookie } from "../../hooks/authCookies";
import { Close } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { openNav } from "../../redux/slices/user/userSlice";
import { useDispatch, useSelector } from "react-redux";


export default function SecondHeader() {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isNavOpen = useSelector(state => state.user.isNavOpen);

  // logger.log("isNavOpen",isNavOpen);

  // isNavOpen


  const currentPath = location.pathname;
  const user = getUserCookie();
  const isAuthenticated = Boolean(user);

  if (isAuthenticated) return null;

  // isAuthenticated ? "/StudentDashboard" :"/admissions"
  const navItems = [
    { key: "home", path: "/home" },
    // { key: "news", path: "/home#news" },
    // { key: "activity", path: "/home#activity" },
    // { key: "FutureVision", path: "/home#FutureVision" },
    { key: "leadersArticles", path: "/leaders-articles" },
    { key: "studentVoices", path: "/student-voices" },
    { key: "academics", path: "/academics" },
    { key: "contactus", path: "/contact-us" },
    ...(isAuthenticated ? [] : [{ key: "admissions.title", path: "/admissions" }]),
    // { key: "support", path: "/support" },
  ];

  const getActive = (path) => {
    if (path === "/") return currentPath == "/home";
    return currentPath.startsWith(path);
  };


  return (
    <Box>
      <Box
        sx={{
          position: "fixed",
          top: { xs: "60px", md: "80px" },
          left: 0,
          right: 0,
          zIndex: 1100,
          display: "flex",
          gap: 1,
          alignItems: "center",
          justifyContent: { xs: "flex-start", md: "center" },
          background: theme.palette.primary.main,
          px: { xs: 2, md: 2 },
          py: { xs: 0.5, md: 1 },
          overflowX: "auto",
          whiteSpace: "nowrap",
          flexWrap: "nowrap",
          WebkitOverflowScrolling: "touch", // Smooth iOS scrolling
          borderBottom: `2px solid ${theme.palette.divider || "rgba(0,0,0,0.12)"}`,
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Safari and Chrome
          },
        }}
      >

        {/* {
          isMobile&&<IconButton onClick={() => {
          // searchParams.set("mobileOpen",true);
          // setSearchParams(searchParams);
            dispatch(openNav());
        }}>
         <MenuIcon fontSize="large" />
        </IconButton>
        }
         */}
        {navItems.map((item) => {
          const active = getActive(item.path);
          return (
            <Button
              key={item.key}
              onClick={() => navigate(item.path)}
              sx={{
                color: active ? theme.palette.secondary.main : theme.palette.text.sec,
                background: "transparent",
                textTransform: "none",
                fontWeight: active ? 700 : 500,
                borderRadius: 1,
                px: { xs: 2, md: 3 },
                py: { xs: 0.5, md: 0.8 },
                textDecoration: active ? "underline" : "none",
                textDecorationColor: active ? theme.palette.secondary.main : "transparent",
                textDecorationThickness: active ? "2px" : "auto", // سماكة الخط
                textUnderlineOffset: active ? "6px" : "0px",     // المسافة بين الكلمة والخط
                "&:hover": {
                  background: active ? theme.palette.secondary.dark : theme.palette.primary.dark,
                },
                flexShrink: 0, // Prevent buttons from shrinking
                whiteSpace: "nowrap", // Prevent button text from wrapping
              }}


            >
              {t(item.key)}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}
